import Util from '../forecast-app/shared/util/util';
import {graphql} from 'react-relay';
import {trackAndCommitMutation} from '../tracking/amplitude/TrackMutation';

const mutation = graphql`
	mutation removeCommentReactionMutation($input: RemoveCommentReactionInput!) {
		removeCommentReaction(input: $input) {
			comment {
				id
				reactions {
					emoji
					count
					viewerHasReacted
					persons {
						id
						fullName
					}
				}
			}
		}
	}
`;

// `optimisticReactions` is client-only: it drives the optimistic response and is never sent.
function commit(environment, {commentId, emoji, optimisticReactions}, onSuccess, onError) {
	return trackAndCommitMutation(environment, {
		mutation,
		variables: {input: {csrfToken: Util.getCsrfValue(), socketClientId: Util.getClientId(), commentId, emoji}},
		optimisticResponse: {removeCommentReaction: {comment: {id: commentId, reactions: optimisticReactions}}},
		onCompleted: onSuccess,
		onError: onError,
	});
}

export default {commit};
